import ConversationLink from './conversation_link';
import React            from 'react';


export default function ChatRooms({ businessID, conversationID }) {
  const uniqueName = `business:${businessID}`;

  return (
    <div className="team-rooms-list list media-list">
      <div className="block-title">Team Rooms</div>
      <ConversationLink
        selectedConversationID={conversationID}
        uniqueName={uniqueName}
        friendlyName={'Everyone'}
        businessID={businessID}
        className="no-border"
      />
    </div>
  );
}
